import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-equities_btn_follow",
  "use": "icon-equities_btn_follow-usage",
  "viewBox": "0 0 10 11",
  "content": "<symbol viewBox=\"0 0 10 11\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-equities_btn_follow\"><path d=\"m3.3 9.3c-.1 0-.3 0-.4-.1-.1-.2-.1-.5.1-.7l3-3-3-3c-.2-.2-.2-.5 0-.7s.5-.2.7 0l3.2 3.2c.3.3.3.7 0 1l-3.2 3.2c-.1.1-.2.1-.4.1z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/equities_btn_follow.svg
// module id = yajy
// module chunks = 87